import React from 'react';
import { Card, Row } from 'react-bootstrap';


class ContentBlockSmall extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const title = this.props.title;

        return (
            <Card className='content-block'>
                <Card.Title className='center-text regular-text' style={{ textTransform: 'uppercase' }}>{title}</Card.Title>
                <Card.Body>
                    <Row>
                        {this.props.children}
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default ContentBlockSmall;